import { useLocation } from 'react-router';

import { useTranslation } from 'app/lang';

import { accessTimePeriodForSports, isFinishedSportMatch } from '../../betting/accessMatchDetails';
import { RecordOfMatchEntity, TennisPeriodType } from '../../betting/betting-entities';
import { SportId } from '../../betting/constants';
import { getFinishedPeriod } from '../get-finished-period';
import { TennisKeyPeriod, TennisTieBreakTypes } from './constants';

import dictionary from './Tennis.dictionary.json';

export const TennisPeriods = (
  sportId?: SportId,
  periods?: RecordOfMatchEntity['periods'],
  tieBreak?: TennisTieBreakTypes | null,
) => {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  const isResults = pathname.includes('results');

  if (isResults || isFinishedSportMatch(sportId, periods)) {
    return getFinishedPeriod(TennisKeyPeriod.FINISHED, t);
  }

  const isSuperTieBreak = (
    tieBreak === TennisTieBreakTypes.SUPER_TIE_BREAK_IN_LAST_SET
    || tieBreak === TennisTieBreakTypes.SUPER_TIE_BREAK_BIG_HELMET
  );

  if (isSuperTieBreak) {
    return {
      key: TennisKeyPeriod.SUPER_TIE_BREAK_PERIOD,
      value: t(dictionary.superTieBreakPeriod),
    };
  }

  const isTieBreak = tieBreak === TennisTieBreakTypes.TIE_BREAK;
  const timePeriod = accessTimePeriodForSports(sportId, periods) || 0;
  const gamePeriod = periods?.get(TennisPeriodType.GAME, null)?.number;

  const game = typeof gamePeriod === 'number'
    ? t(dictionary.gamePeriod, { gamePeriod })
    : null;

  const period = timePeriod !== null
    ? t(dictionary.timePeriod, { timePeriod })
    : null;

  const tieBreakPeriod = isTieBreak
    ? t(dictionary.tieBreakPeriod)
    : null;

  if (isTieBreak) {
    return {
      key: TennisKeyPeriod.TIE_BREAK_PERIOD,
      value: {
        period,
        tieBreakPeriod,
      },
    };
  }

  return {
    key: TennisKeyPeriod.GAME_AND_PERIOD,
    value: {
      game,
      period,
    },
  };
};
